import { useTranslation } from 'react-i18next';
import { Box, Grid, SxProps } from '@mui/material';
import { Body, H6 } from '../Typography';
import { FCardBlocks } from '../../assets/icons';
import { shadows } from '../../lightTheme';

const FamiliplusProfileCard = (props: {
  fullName: string;
  cardNumber: string;
  numberOfPoints: number;
  valueOfPoints: number;
  sx?: SxProps;
}): JSX.Element => {
  const { t } = useTranslation('familiplusPage');
  const pointsValue = (Math.round(props.valueOfPoints * 100) / 100).toFixed(2);

  return (
    <Box
      id="familiplusProfileCard"
      sx={{
        position: 'relative',
        background: 'radial-gradient(50% 50% at 50% 50%, #FFFFFF 0%, #EDEDED 100%)',
        width: '100%',
        overflow: 'hidden',
        padding: '16px',
        boxShadow: shadows.lightBox,
        ...props.sx,
      }}>
      <Grid container direction="column" justifyContent="space-between" sx={{ height: '100%' }}>
        <Grid item>
          <H6 data-cy="fullName" sx={{ mb: '3px' }}>
            <strong>{props.fullName}</strong>
          </H6>
          <Box data-cy="cardNumber" sx={{ color: (theme) => theme.palette.primary.main }}>
            {props.cardNumber}
          </Box>
        </Grid>
        <Grid item sx={{ color: (theme) => theme.palette.error.main }}>
          <H6 data-cy="numberOfPoints">
            <strong>{t('cardMember.nbrPointsShort', { count: props.numberOfPoints })}</strong>
          </H6>
          <Body data-cy="pointsValue">{t('cardMember.valueOfPoints', { amount: pointsValue })}</Body>
        </Grid>
      </Grid>
      <FCardBlocks data-cy="FCardBlocks" style={{ bottom: '-20px', right: '38px', position: 'absolute' }} />
    </Box>
  );
};

export default FamiliplusProfileCard;
